import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import { RangeSliderInput } from '../../slider/RangeSliderInput';

export type RangeSliderProps = VFFieldProps<
  React.ComponentProps<typeof RangeSliderInput>
>;
export const RangeSlider = React.forwardRef<HTMLInputElement, RangeSliderProps>(
  (
    {
      name,
      inlineValidation,
      validate,
      className,
      inputClassName,
      contentClassName,
      label,
      required,
      disabled,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, onBlur, name, ...nother },
            meta,
          }: FieldRenderProps<[number, number]>) => {
            return (
              <RangeSliderInput
                className={inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                // @ts-ignore
                name={name}
                {...other}
                disabled={disabled || meta.submitting}
                value={value}
                onChange={(newValue) => {
                  const e = { target: { name, value: newValue } };
                  onChange(e);
                  other?.onChange?.(e);
                }}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
